package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2026_02_07_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2026-02-07")
@Composable
public fun Log_2026_02_07(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Meet the Former Lord… and His Two Wives",
        ogTitle = "Meet the Former Lord… and His Two Wives",
        date = LocalDate(2_026, 2, 7),
        aiHint = "Image, title, and description suggest the lord has multiple wives as a joke because the floor plan had an error where a room was mislabeled.",
        ogDescription = "The heroes ponder the mysteries of matrimony, architecture, and smoky auras while Bigglesworth digs for treasure and hopes for tuna.",
        ogImage = "images/lordFoxSeniorFamilyPortrait_preview.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "A hand-drawn family portrait of a regal man and two elegantly dressed women. The heroes found this drawing in the attic of Lord Fox's family estate, and it is meant to represent an elder Lord Fox's sister wives.",
    ) {
        SessionDayHeader(dayId = "shimmer-10", dateString = "Shimmer 10")
        Log_2026_02_07_Day_1()
        SessionMediaItem(
            image = "images/lordFoxSeniorFamilyPortrait.webp",
            linkImage = "images/lordFoxSeniorFamilyPortrait.webp",
            description = "A hand-drawn family portrait of a regal man and two elegantly dressed women. The heroes found this drawing in the attic of Lord Fox's family estate, and it is meant to represent an elder Lord Fox's sister wives.",
            width = 4_032,
            height = 3_024,
        )
    }
}
